import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import {Calibration_Interface,Empty_Calibration_Interface,} from 'src/app/Interface/Calibration_Interface';
import {DataEntity_Detail_02_Interface,Empty_DataEntity_Detail_02_Interface} from 'src/app/Interface/DataEntity/02/DataEntity_Detail_02_Interface';
import {DataEntity_Main_02_Interface,Empty_DataEntity_Main_02_Interface} from 'src/app/Interface/DataEntity/02/DataEntity_Main_02_Interface';
import { Device_MPE_Interface } from 'src/app/Interface/Device_MPE_Interface';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { Unit_Interface } from 'src/app/Interface/Unit_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CalibrationService } from 'src/app/Service/Calibration/Calibration.service';
import { DataEntity02ServiceService } from 'src/app/Service/DataEntity/02/DataEntity02.service';
import { DataEntityMainService } from 'src/app/Service/DataEntity/DataEntityMain.service';
import { UnitService } from 'src/app/Service/Unit/Unit.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-DataEntity02',
  templateUrl: './DataEntity02.component.html',
  styleUrls: ['./DataEntity02.component.scss'],
})
export class DataEntity02Component implements OnInit {

  constructor(
    private Calibration_Service: CalibrationService,
    private DataEntity02_Service: DataEntity02ServiceService,
    private DataEntityMain_Service: DataEntityMainService,
    private Alerify_Service: AlertifyService,
    private Unit_Service: UnitService,
    private modalService: BsModalService,
    private route: ActivatedRoute
  ) {}
  FileName: string = '';
  FolderName: string = '';
  Capability: string = '';
  DataEntity_Id: number = 2;
  CertificateCode: String = '';

  Manufacture_txt: String = '';
  Type_txt: String = '';
  Model_txt: String = '';

  DELIVERY_TIME: number = 0;
  InProccessing: boolean = false;
  Calibration_Device_Id: number = 0;

  Calibration_Id: number = 0;
  Observation: number = 0;
  Device_MPE_List: Array<Device_MPE_Interface> = []

  CertificateUrlPdf:string=''


  unit_nomimal:string=''
  unit_reference:string=''
  unit_correction:string=''
  unit_correction_eqution:string=''
  unit_uncertainy:string=''
  unit_zfactor:string=''


  ngOnInit() {

    this.MainFormDataEntity = new FormGroup({
      id: new FormControl(),

      //Temperature_Water_before: new FormControl(null, [Validators.required,Validators.pattern('1[7-9]|2[0-3]\.[0-9]{1}$')]),
      //Temperature_Water_after: new FormControl(null, [Validators.required,Validators.pattern('1[7-9]|2[0-3]\.[0-9]{1}$')]),

      Temperature_Water_before: new FormControl(null, [Validators.required]),
      Temperature_Water_after: new FormControl(null, [Validators.required]),

      //Temperature_Air_before: new FormControl(null, [Validators.required,Validators.pattern('1[7-9]|2[0-3]\.[0-9]{1}$')]),
      //Temperature_Air_after: new FormControl(null, [Validators.required, Validators.pattern('1[7-9]|2[0-3]\.[0-9]{1}$')]),

      Temperature_Air_before: new FormControl(null, [Validators.required]),
      Temperature_Air_after: new FormControl(null, [Validators.required]),

      //Humidity_Air_before: new FormControl(null, [Validators.required,Validators.pattern('[1-9]|[1-9][0-9]|[1-9][0-9][0-9]|[1-9][0-9][0-9][0-9]$')]),
      //Humidity_Air_after: new FormControl(null, [Validators.required, Validators.pattern('[1-9]|[1-9][0-9]|[1-9][0-9][0-9]|[1-9][0-9][0-9][0-9]$')]),

      Humidity_Air_before: new FormControl(null, [Validators.required]),
      Humidity_Air_after: new FormControl(null, [Validators.required]),

      //Pressure_before: new FormControl(null, [Validators.required,Validators.pattern('[1-9]|[1-9][0-9]|[1-9][0-9][0-9]|[1-9][0-9][0-9][0-9]$')]),
      //Pressure_after: new FormControl(null, [Validators.required, Validators.pattern('[1-9]|[1-9][0-9]|[1-9][0-9][0-9]|[1-9][0-9][0-9][0-9]$')]),

      Pressure_before: new FormControl(null, [Validators.required]),
      Pressure_after: new FormControl(null, [Validators.required]),

      Reference_Temperature: new FormControl('20', Validators.required),

      Temperature_Device: new FormControl(null),
      PA_Device: new FormControl(null),
      PW_Device: new FormControl(null),

      range_max: new FormControl(null),
      range_min: new FormControl(null),
      scale: new FormControl(null),

      Nominal_Value: new FormControl(null, Validators.required),
      y_A: new FormControl(8.0, Validators.required),
      y: new FormControl(0.00001, Validators.required),
    });

    this.DetailFormDataEntity = new FormGroup({
      id: new FormControl(),
      Mesured_Mass: new FormControl(null),
    });

    this.Calibration_Device_Id = Number(this.route.snapshot.paramMap.get('id'));
    this.OnIntial();
  }

  OnIntial() {
    this.DataEntity02_Service.GetSingle(this.Calibration_Device_Id,this.DataEntity_Id).subscribe(
      (data) => {
        if (data['result'] != null) {
          var temp: DataEntity_Main_02_Interface = Empty_DataEntity_Main_02_Interface();
          this.Device_MPE_List = data['mpe'];
          this.Observation = data['observation'];

          temp = data['result'];
          this.Calibration_Id = temp.id;
          this.FileName = temp.filename;
          this.FolderName = temp.pdf_src;
          this.Capability = temp.capability;
          this.DELIVERY_TIME = Number(temp.delivery_time+'');

          this.unit_nomimal = temp.unit_nomimal;
          this.unit_reference = temp.unit_reference;
          this.unit_correction = temp.unit_correction;
          this.unit_correction_eqution = temp.unit_correction_eqution;
          this.unit_uncertainy = temp.unit_uncertainy;
          this.unit_zfactor = temp.unit_zfactor;


          this.Manufacture_txt = temp.manufacture;
          this.Type_txt = temp.type;
          this.Model_txt = temp.model;

          if (data['certificateUrl'])
            this.CertificateUrlPdf = environment.BaseUrl + data['certificateUrl']
          else
            this.CertificateUrlPdf = ""

          var First_After_Indexer:number=-1
          for (let item of data['detail']) {

            var tempDetail: DataEntity_Detail_02_Interface = Empty_DataEntity_Detail_02_Interface();



            this.get_Form_Temperature_Water_before().setValue(item['temperature_Water_before']);
            this.get_Form_Temperature_Water_after().setValue(item['temperature_Water_after']);

            this.get_Form_Temperature_Air_before().setValue(item['temperature_Air_before']);
            this.get_Form_Temperature_Air_after().setValue(item['temperature_Air_after']);

            this.get_Form_Humidity_Air_before().setValue(item['humidity_Air_before']);
            this.get_Form_Humidity_Air_after().setValue(item['humidity_Air_after']);

            this.get_Form_Pressure_before().setValue(item['pressure_before']);
            this.get_Form_Pressure_after().setValue(item['pressure_after']);

            this.get_Form_Reference_Temperature().setValue(item['reference_Temperature']);

            this.Calc_Main_Function();


            tempDetail.temperature_Water_before = this.get_Form_Temperature_Water_before().value
            tempDetail.temperature_Water_after = this.get_Form_Temperature_Water_after().value

            tempDetail.temperature_Air_before = this.get_Form_Temperature_Air_before().value
            tempDetail.temperature_Air_after = this.get_Form_Temperature_Air_after().value

            tempDetail.humidity_Air_before = this.get_Form_Humidity_Air_before().value
            tempDetail.humidity_Air_after = this.get_Form_Humidity_Air_after().value

            tempDetail.pressure_before = this.get_Form_Pressure_before().value
            tempDetail.pressure_after = this.get_Form_Pressure_after().value

            tempDetail.PA = this.get_Form_PA_Device().value
            tempDetail.PW = this.get_Form_PW_Device().value
            tempDetail.Temperature_Device = this.get_Form_Temperature_Device().value

            tempDetail.reference_Temperature = Number(this.get_Form_Reference_Temperature().value);





            tempDetail.nominal = item['nominal'];
            tempDetail.mesured = item['mesured'];
            tempDetail.uncertainty = item['uncertainty'];
            tempDetail.zFactor = item['zfactor'];
            tempDetail.converage = item['converage'];
            tempDetail.value = item['value'];
            tempDetail.yb = item['yb'];
            tempDetail.y = item['y'];

            tempDetail.range_max = item['range_max'];
            tempDetail.range_min = item['range_min'];
            tempDetail.scale = item['scale'];

            tempDetail.before = item['before'];

            tempDetail.mpe_goal = item['mpe_goal'];
            tempDetail.mpe_max = item['mpe_max'];
            tempDetail.mpe_min = item['mpe_min'];

            tempDetail.mpe_rnd = item['mpe_rnd'];
            tempDetail.mpe_sys = item['mpe_sys'];

            var avg: number = 0;
            var Mesured_Mass_List_Number: Array<number> = [];
            for (let item of tempDetail.mesured) {
              avg = avg + Number(item);
              Mesured_Mass_List_Number.push(Number(item));
            }

            tempDetail.average = avg / tempDetail.mesured.length;
            tempDetail.sd = this.getStandardDeviation(Mesured_Mass_List_Number,tempDetail.average);
            tempDetail.cv = (100 * tempDetail.sd) / tempDetail.average;

            if (First_After_Indexer!=-1)
            {
              tempDetail.cv = tempDetail.cv * (tempDetail.nominal/this.Nominal_Value_List[First_After_Indexer].nominal)
            }

            tempDetail.reference_Value = tempDetail.average * Math.pow(Number(tempDetail.PW) - Number(tempDetail.PA),-1) * (1 - (Number(tempDetail.PA) / Number(tempDetail.yb)) * (1 - Number(tempDetail.y) * (Number(tempDetail.Temperature_Device) - Number(tempDetail.reference_Temperature))));
            //tempDetail.zFactor = (Number(tempDetail.yb) - Number(tempDetail.PA)) / (Number(tempDetail.yb) * (Number(tempDetail.PW) - Number(tempDetail.PA)));
            tempDetail.error = Math.abs(tempDetail.nominal - tempDetail.reference_Value)

            this.Nominal_Value_List.push(tempDetail);

            if (tempDetail.before == false && First_After_Indexer == -1)
            {
              First_After_Indexer = this.Nominal_Value_List.length - 1
            }


          }
        }
        this.Read_Unit()
        //this.MainDataEntity_List = data['result']
        //this.UploadImageSrc_List = data['image']
        //this.canAdd_SubmitDATEOFISSUE_Date = data['canAdd_SubmitDATEOFISSUE_Date']
        //this.SubmitDATEOFISSUE_Date = data['certificate_Code']['date_of_issue']

        this.CertificateCode = data['certificate_Code'];
      },
      (error) => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    );
  }

  //#region Main Data Entity

  MainFormDataEntity: FormGroup;

  get_Form_Temperature_Water_before() {
    return this.MainFormDataEntity.get(
      'Temperature_Water_before'
    ) as FormControl;
  }
  get_Form_Temperature_Water_after() {
    return this.MainFormDataEntity.get(
      'Temperature_Water_after'
    ) as FormControl;
  }

  get_Form_Temperature_Air_before() {
    return this.MainFormDataEntity.get('Temperature_Air_before') as FormControl;
  }
  get_Form_Temperature_Air_after() {
    return this.MainFormDataEntity.get('Temperature_Air_after') as FormControl;
  }

  get_Form_Humidity_Air_before() {
    return this.MainFormDataEntity.get('Humidity_Air_before') as FormControl;
  }
  get_Form_Humidity_Air_after() {
    return this.MainFormDataEntity.get('Humidity_Air_after') as FormControl;
  }

  get_Form_Pressure_before() {
    return this.MainFormDataEntity.get('Pressure_before') as FormControl;
  }
  get_Form_Pressure_after() {
    return this.MainFormDataEntity.get('Pressure_after') as FormControl;
  }

  get_Form_Reference_Temperature() {
    return this.MainFormDataEntity.get('Reference_Temperature') as FormControl;
  }
  get_Form_Temperature_Device() {
    return this.MainFormDataEntity.get('Temperature_Device') as FormControl;
  }

  get_Form_PA_Device() {
    return this.MainFormDataEntity.get('PA_Device') as FormControl;
  }

  get_Form_PW_Device() {
    return this.MainFormDataEntity.get('PW_Device') as FormControl;
  }

  get_Form_Nominal_Value() {
    return this.MainFormDataEntity.get('Nominal_Value') as FormControl;
  }

  get_Form_range_min() {
    return this.MainFormDataEntity.get('range_min') as FormControl;
  }

  get_Form_range_max() {
    return this.MainFormDataEntity.get('range_max') as FormControl;
  }

  get_Form_scale() {
    return this.MainFormDataEntity.get('scale') as FormControl;
  }

  get_Form_y_A() {
    return this.MainFormDataEntity.get('y_A') as FormControl;
  }

  get_Form_y() {
    return this.MainFormDataEntity.get('y') as FormControl;
  }

  Calc_Main_Function() {
    var temp =
      (Number(this.get_Form_Temperature_Air_before().value) +
        Number(this.get_Form_Temperature_Air_after().value)) /
      2;
    this.get_Form_Temperature_Device().setValue(temp);

    temp =
      ((0.34848 * Number(this.get_Form_Pressure_before().value) -
        0.009 *
          Number(this.get_Form_Humidity_Air_before().value) *
          Math.exp(
            0.061 * Number(this.get_Form_Temperature_Air_before().value)
          )) /
        (Number(this.get_Form_Temperature_Air_before().value) + 273.15)) *
      0.001;
    this.get_Form_PA_Device().setValue(temp);

    var temp2 =
      Number(this.get_Form_Temperature_Water_before().value) - 3.983035;
    temp =
      0.99997495 *
      (1 -
        ((Number(this.get_Form_Temperature_Water_before().value) + 301.797) *
          Math.pow(temp2, 2)) /
          (522528.9 *
            (Number(this.get_Form_Temperature_Water_before().value) +
              69.34881)));
    this.get_Form_PW_Device().setValue(temp);
  }

  MainFormDataEntity_Submit() {
    //this.MainDataEntity_List.push(temp)
    this.Alerify_Service.SuccessMessage('به جدول اضافه شد');

    //this.DetailDataEntity_List = []
    this.MainFormDataEntity.reset();
  }

  //#endregion

  //#region Detail Data Entity

  DetailFormDataEntity: FormGroup;

  get_Form_Mesured_Mass() {
    return this.DetailFormDataEntity.get('Mesured_Mass') as FormControl;
  }

  //#endregion

  //#region Mesured Mass

  Mesured_Mass_List: Array<General_Interface> = [];

  Add_Mesured_Mass_List() {
    if (!this.get_Form_Mesured_Mass().value)
      this.Alerify_Service.ErrorMessage('مقدار Mesured Mass را وارد نمائید');
    else {
      var temp: General_Interface = Empty_General_Interface();
      temp.title=this.get_Form_Mesured_Mass().value
      this.Mesured_Mass_List.push(temp);
      this.Alerify_Service.SuccessMessage('Mesured Mass به لیست اضافه شد');
      this.get_Form_Mesured_Mass().setValue('');
    }
  }

  Delete_Mesured_Mass_List(id: number) {
    this.Mesured_Mass_List.splice(id, 1);
    this.Alerify_Service.SuccessMessage('Mesured Mass از لیست حذف شد');
  }

  //#endregion

  //#region Nominal Value

  Nominal_Value_List_Edit_Index:number=-1
  Showing_Form_Nominal_Value:boolean=false
  Nominal_Value_List: Array<DataEntity_Detail_02_Interface> = [];
  DataEntity_Detail_Global: DataEntity_Detail_02_Interface = Empty_DataEntity_Detail_02_Interface();

  Add_Nominal_Value(template: TemplateRef<any>,Confirm:number) {
    if (this.Mesured_Mass_List.length < this.Observation) {
      this.Alerify_Service.ErrorMessage('حداقل '+this.Observation+' Mesured Mass وارد نمائید ');
    }
    else {

      var First_After_Indexer:number=-1
      for (let item of this.Nominal_Value_List)
      {
        if (item.before == false)
        {
          First_After_Indexer = this.Nominal_Value_List.indexOf(item)
        }
      }

      var temp_mesured_list: Array<string> = []
      for (let item of this.Mesured_Mass_List)
      {
        temp_mesured_list.push(item.title+'')
      }

      var temp: DataEntity_Detail_02_Interface = Empty_DataEntity_Detail_02_Interface();
      temp.id = 0;
      temp.nominal = Number(this.get_Form_Nominal_Value().value);
      temp.mesured = temp_mesured_list;
      temp.yb = this.get_Form_y_A().value;
      temp.y = this.get_Form_y().value;

      temp.range_max = this.get_Form_range_max().value+''
      temp.range_min = this.get_Form_range_min().value+''
      temp.scale = this.get_Form_scale().value+''

      temp.temperature_Water_before = this.get_Form_Temperature_Water_before().value+''
      temp.temperature_Water_after = this.get_Form_Temperature_Water_after().value+''

      temp.temperature_Air_before = this.get_Form_Temperature_Air_before().value+''
      temp.temperature_Air_after = this.get_Form_Temperature_Air_after().value+''

      temp.humidity_Air_before = this.get_Form_Humidity_Air_before().value+''
      temp.humidity_Air_after = this.get_Form_Humidity_Air_after().value+''

      temp.pressure_before = this.get_Form_Pressure_before().value+''
      temp.pressure_after = this.get_Form_Pressure_after().value+''

      temp.PA = this.get_Form_PA_Device().value+''
      temp.PW = this.get_Form_PW_Device().value+''
      temp.Temperature_Device = this.get_Form_Temperature_Device().value+''

      temp.reference_Temperature = Number(this.get_Form_Reference_Temperature().value);

      if (this.Device_MPE_List.length > 0)
      {
        for (let item of this.Device_MPE_List)
        {
          if (item.mpe_min <= temp.nominal && item.mpe_max >= temp.nominal)
          {
            temp.mpe_min=item.mpe_min
            temp.mpe_max = item.mpe_max
            temp.mpe_goal = item.mpe_goal

            temp.mpe_rnd=item.mpe_rnd
            temp.mpe_sys = item.mpe_sys
            //temp.floatPoint = '1.2-' + (item.mpe_rnd + "").split(".")[1].length;
            break
          }
        }
      }

      var avg: number = 0;
      var Mesured_Mass_List_Number: Array<number> = [];
      for (let item of temp.mesured) {
        avg = avg + Number(item);
        Mesured_Mass_List_Number.push(Number(item));
      }



      temp.average = avg / temp.mesured.length;
      temp.sd = this.getStandardDeviation(Mesured_Mass_List_Number, temp.average);
      /*
      temp.cv = (100 * temp.sd) / temp.average;

      if (First_After_Indexer!=-1)
      {
        temp.cv = temp.cv * (temp.nominal/this.Nominal_Value_List[First_After_Indexer].nominal)
      }

      temp.reference_Value = temp.average * Math.pow(Number(this.get_Form_PW_Device().value) - Number(this.get_Form_PA_Device().value), -1 ) * (1 - (Number(this.get_Form_PA_Device().value) / Number(temp.yb)) * (1 - Number(temp.y) * (Number(this.get_Form_Temperature_Device().value) - Number(this.get_Form_Reference_Temperature().value))));
      temp.zFactor = (Number(temp.yb) - Number(this.get_Form_PA_Device().value)) / (Number(temp.yb) * (Number(this.get_Form_PW_Device().value) - Number(this.get_Form_PA_Device().value)));
      temp.error = Math.abs(temp.nominal - temp.reference_Value)

      temp.reference_Temperature = Number(this.get_Form_Reference_Temperature().value);
      */
      temp.zFactor = this.Nominal_Value_List[this.Nominal_Value_List_Edit_Index].zFactor
      temp.uncertainty = this.Nominal_Value_List[this.Nominal_Value_List_Edit_Index].uncertainty
      temp.converage = this.Nominal_Value_List[this.Nominal_Value_List_Edit_Index].converage
      temp.before = this.Nominal_Value_List[this.Nominal_Value_List_Edit_Index].before

      if(temp.before==true)
      {
        temp.value = (Number(temp.zFactor) * temp.average )+''
      }
      else{
        temp.value = this.Nominal_Value_List[this.Nominal_Value_List_Edit_Index].value
      }


      if(temp.range_max && !temp.range_min)
      {
        temp.range_min = temp.range_max
        this.get_Form_range_min().setValue(temp.range_min)
      }
      else if(!temp.range_max && temp.range_min)
      {
        temp.range_max = temp.range_min
        this.get_Form_range_max().setValue(temp.range_max)
      }


      if (Confirm == 1)
      {
        this.Nominal_Value_List[this.Nominal_Value_List_Edit_Index]=temp
        this.Mesured_Mass_List = [];

        this.Showing_Form_Nominal_Value=false
      }
      else if(temp.range_max && temp.range_min && Number(temp.range_min)<=temp.nominal && temp.nominal<=Number(temp.range_max))
      {
        this.Nominal_Value_List[this.Nominal_Value_List_Edit_Index]=temp
        this.Mesured_Mass_List = [];

        this.Showing_Form_Nominal_Value=false
      }
      else if (!temp.range_max && !temp.range_min)
      {
        this.Nominal_Value_List[this.Nominal_Value_List_Edit_Index]=temp
        this.Mesured_Mass_List = [];

        this.Showing_Form_Nominal_Value=false
      }
      else {
        this.modalRef_After = this.modalService.show(template);
      }

    }
  }

  Confirm_Nominal_Value(id: number) {
    if (id == 1) {
      this.Add_Nominal_Value(null,1)
    }
    this.modalRef_After.hide()
  }

  getStandardDeviation(arr: Array<number>, avg: number) {
    var sum: number = 0;
    for (let item of arr) {
      sum = sum + Math.pow(item - avg, 2);
    }
    return Math.sqrt(sum / (arr.length-1));
  }

  Delete_Nominal_Value_List(id: number) {
    this.Nominal_Value_List.splice(id, 1);
    this.Alerify_Service.SuccessMessage('Mesured Mass از لیست حذف شد');
  }

  Edit_Nominal_Value_List(id: number) {
    var temp = this.Nominal_Value_List[id];
    this.Nominal_Value_List_Edit_Index=id

    this.get_Form_Temperature_Water_before().setValue(temp.temperature_Water_before)
    this.get_Form_Temperature_Water_after().setValue(temp.temperature_Water_after)

    this.get_Form_Temperature_Air_before().setValue(temp.temperature_Air_before)
    this.get_Form_Temperature_Air_after().setValue(temp.temperature_Air_after)

    this.get_Form_Humidity_Air_before().setValue(temp.humidity_Air_before)
    this.get_Form_Humidity_Air_after().setValue(temp.humidity_Air_after
    )
    this.get_Form_Pressure_before().setValue(temp.pressure_before)
    this.get_Form_Pressure_after().setValue(temp.pressure_after)

    this.get_Form_Reference_Temperature().setValue(temp.reference_Temperature)
    this.get_Form_Nominal_Value().setValue(temp.nominal)

    this.get_Form_Reference_Temperature().setValue(temp.reference_Temperature)

    this.get_Form_range_min().setValue(temp.range_min)
    this.get_Form_range_max().setValue(temp.range_max)
    this.get_Form_scale().setValue(temp.scale)

    this.get_Form_y_A().setValue(temp.yb)
    this.get_Form_y().setValue(temp.y)


    this.Calc_Main_Function()

    this.Mesured_Mass_List = []
    for (let item of temp.mesured)
    {
      var tempMeasure: General_Interface = Empty_General_Interface();
      tempMeasure.title=item
      this.Mesured_Mass_List.push(tempMeasure)
    }

    this.Showing_Form_Nominal_Value=true

    //this.get_Form_Temperature_Device().setValue(temp.Temperature_Device)
    //this.PA_Device().setValue(temp.Temperature_Device)
    //this.PW_Device().setValue(temp.Temperature_Device)

  }

  Visible_Nominal_Value_List(id: number) {
    this.Nominal_Value_List[id].mesured_visible =
      !this.Nominal_Value_List[id].mesured_visible;
  }

  Cancel_Nominal_Value_List() {
    this.Nominal_Value_List_Edit_Index = -1
    this.Showing_Form_Nominal_Value=false
  }

  Copy_From_Up(id: number)
  {
    var UpRecord =this.Nominal_Value_List[id-1];
    var CurrentRecord =this.Nominal_Value_List[id];

    CurrentRecord.temperature_Water_before = UpRecord.temperature_Water_before
    CurrentRecord.temperature_Water_after =  UpRecord.temperature_Water_after

    CurrentRecord.temperature_Air_before =  UpRecord.temperature_Air_before
    CurrentRecord.temperature_Air_after =  UpRecord.temperature_Air_after

    CurrentRecord.humidity_Air_before =  UpRecord.humidity_Air_before
    CurrentRecord.humidity_Air_after =  UpRecord.humidity_Air_after

    CurrentRecord.pressure_before =  UpRecord.pressure_before
    CurrentRecord.pressure_after =  UpRecord.pressure_after

    CurrentRecord.PA = UpRecord.PA
    CurrentRecord.PW = UpRecord.PW
    CurrentRecord.Temperature_Device = UpRecord.Temperature_Device
    CurrentRecord.reference_Temperature =  UpRecord.reference_Temperature


    var avg: number = 0;
    var Mesured_Mass_List_Number: Array<number> = [];
    for (let item of CurrentRecord.mesured) {
      avg = avg + Number(item);
      Mesured_Mass_List_Number.push(Number(item));
    }

    CurrentRecord.average = avg / CurrentRecord.mesured.length;
    CurrentRecord.sd = this.getStandardDeviation(Mesured_Mass_List_Number,CurrentRecord.average);
    CurrentRecord.cv = (100 * CurrentRecord.sd) / CurrentRecord.average;

    if (id > 1)
    {
      CurrentRecord.cv = CurrentRecord.cv * (CurrentRecord.nominal/this.Nominal_Value_List[1].nominal)
    }

    CurrentRecord.reference_Value = CurrentRecord.average * Math.pow(Number(CurrentRecord.PW) - Number(CurrentRecord.PA), -1 ) * (1 - (Number(CurrentRecord.PA) / Number(CurrentRecord.yb)) * (1 - Number(CurrentRecord.y) * (Number(CurrentRecord.Temperature_Device) - Number(CurrentRecord.reference_Temperature))));
    //CurrentRecord.zFactor = (Number(CurrentRecord.yb) - Number(CurrentRecord.PA)) / (Number(CurrentRecord.yb) * (Number(this.get_Form_PW_Device().value) - Number(CurrentRecord.PA)));
    CurrentRecord.error = Math.abs(CurrentRecord.nominal - CurrentRecord.reference_Value)

    CurrentRecord.reference_Temperature = Number(CurrentRecord.reference_Temperature);
  }

  Copy_From_Down(id: number)
  {
    var DownRecord =this.Nominal_Value_List[id+1];
    var CurrentRecord =this.Nominal_Value_List[id];

    CurrentRecord.temperature_Water_before = DownRecord.temperature_Water_before
    CurrentRecord.temperature_Water_after =  DownRecord.temperature_Water_after

    CurrentRecord.temperature_Air_before =  DownRecord.temperature_Air_before
    CurrentRecord.temperature_Air_after =  DownRecord.temperature_Air_after

    CurrentRecord.humidity_Air_before =  DownRecord.humidity_Air_before
    CurrentRecord.humidity_Air_after =  DownRecord.humidity_Air_after

    CurrentRecord.pressure_before =  DownRecord.pressure_before
    CurrentRecord.pressure_after =  DownRecord.pressure_after

    CurrentRecord.PA = DownRecord.PA
    CurrentRecord.PW = DownRecord.PW
    CurrentRecord.Temperature_Device = DownRecord.Temperature_Device
    CurrentRecord.reference_Temperature =  DownRecord.reference_Temperature


    var avg: number = 0;
    var Mesured_Mass_List_Number: Array<number> = [];
    for (let item of CurrentRecord.mesured) {
      avg = avg + Number(item);
      Mesured_Mass_List_Number.push(Number(item));
    }

    CurrentRecord.average = avg / CurrentRecord.mesured.length;
    CurrentRecord.sd = this.getStandardDeviation(Mesured_Mass_List_Number,CurrentRecord.average);
    CurrentRecord.cv = (100 * CurrentRecord.sd) / CurrentRecord.average;

    if (id > 1)
    {
      CurrentRecord.cv = CurrentRecord.cv * (CurrentRecord.nominal/this.Nominal_Value_List[1].nominal)
    }

    //CurrentRecord.reference_Value = CurrentRecord.average * Math.pow(Number(CurrentRecord.PW) - Number(CurrentRecord.PA), -1 ) * (1 - (Number(CurrentRecord.PA) / Number(CurrentRecord.yb)) * (1 - Number(CurrentRecord.y) * (Number(CurrentRecord.Temperature_Device) - Number(CurrentRecord.reference_Temperature))));
    //CurrentRecord.zFactor = (Number(CurrentRecord.yb) - Number(CurrentRecord.PA)) / (Number(CurrentRecord.yb) * (Number(this.get_Form_PW_Device().value) - Number(CurrentRecord.PA)));
    CurrentRecord.error = Math.abs(CurrentRecord.nominal - CurrentRecord.reference_Value)

    CurrentRecord.reference_Temperature = Number(CurrentRecord.reference_Temperature);
  }

  Copy_After_As_Before()
  {
    var Nominal_Value_List_Temp: Array<DataEntity_Detail_02_Interface> = [];
    var temp_Before: DataEntity_Detail_02_Interface = Empty_DataEntity_Detail_02_Interface();

    temp_Before.id = 0
    temp_Before.nominal = this.Nominal_Value_List[0].nominal
    temp_Before.mesured = this.Nominal_Value_List[0].mesured
    temp_Before.uncertainty = this.Nominal_Value_List[0].uncertainty
    temp_Before.value = this.Nominal_Value_List[0].value
    temp_Before.zFactor = this.Nominal_Value_List[0].zFactor
    temp_Before.converage = this.Nominal_Value_List[0].converage
    temp_Before.before = true

    Nominal_Value_List_Temp.push(temp_Before);
    for (let item of this.Nominal_Value_List)
    {
      Nominal_Value_List_Temp.push(item);
    }
    this.Nominal_Value_List= Nominal_Value_List_Temp
  }


  //#endregion

  //#region Upload

  Procssing_Import:boolean=false
  upload_file_excel(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();

    for (const file of files) {
      formData.append(file.name, file);
    }

    this.Procssing_Import=true

    this.DataEntity02_Service.uploadFile(formData).subscribe(
      data=>{
        this.Procssing_Import=false
        if(data['dsc'])
        {
          this.Alerify_Service.ErrorMessage(data['dsc'])
        }
        else {
          this.Nominal_Value_List=[]
          this.Alerify_Service.SuccessMessage("اطلاعات خوانده شد")

          this.FileName = data['filename']
          this.Capability = data['capability']

          for (let item of data['nominal'])
          {
            var temp: DataEntity_Detail_02_Interface = Empty_DataEntity_Detail_02_Interface()
            //temp.floatPoint=item['floatPoint']
            temp.uncertainty=item['uncertainty']
            temp.mesured = item['mesured']
            temp.zFactor = item['zfactor']
            temp.converage = item['converage']
            temp.value = item['value']


            this.Nominal_Value_List.push(temp)

          }

        }
      }
    )

  }

  Procssing_Import2:boolean=false
  upload_file_pdf(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();

    for (const file of files) {
      formData.append(file.name, file);
    }

    this.Procssing_Import2=true

    this.DataEntity02_Service.uploadPdf(formData).subscribe(
      data=>{
        this.Procssing_Import2=false
        if(data['dsc'])
        {
          this.Alerify_Service.ErrorMessage(data['dsc'])
        }
        else {
          this.Alerify_Service.SuccessMessage("اطلاعات خوانده شد")
          this.FolderName=data['fodlername']

        }
      }
    )

  }

  //#endregion

  //#region Unit
  modalRef_Unit:any
  DataList_Unit:Array<Unit_Interface>=[]
  Read_Unit() {
    this.Unit_Service.GetDataEntity(this.DataEntity_Id).subscribe(
      data => {
        this.DataList_Unit=data
      },
      (error) => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
  }

  Selected_Unit:string=''

  OnUserSetUnit(index:Number,template: TemplateRef<any>){
    if(!this.unit_nomimal && index!=1)
      this.Set_Selected_Unit(index,template)
    else if(!this.unit_reference && index!=2)
      this.Set_Selected_Unit(index,template)
    else if(!this.unit_correction && index!=3)
      this.Set_Selected_Unit(index,template)
    else if(!this.unit_correction_eqution && index!=4)
      this.Set_Selected_Unit(index,template)
    else if(!this.unit_uncertainy && index!=5)
      this.Set_Selected_Unit(index,template)
    else if(!this.unit_zfactor && index!=6)
      this.Set_Selected_Unit(index,template)
  }

  Set_Selected_Unit(index:Number,template: TemplateRef<any>){
    if(index==1)
      this.Selected_Unit=this.unit_nomimal
    else if(index==2)
      this.Selected_Unit=this.unit_reference
    else if(index==3)
      this.Selected_Unit=this.unit_correction
    else if(index==4)
      this.Selected_Unit=this.unit_correction_eqution
    else if(index==5)
      this.Selected_Unit=this.unit_uncertainy
    else if(index==6)
      this.Selected_Unit=this.unit_zfactor

    if(this.Selected_Unit)
      this.modalRef_Unit = this.modalService.show(template);
  }

  SetToAllUnit(){
    if(!this.unit_nomimal)
      this.unit_nomimal=this.Selected_Unit

    if(!this.unit_reference)
      this.unit_reference=this.Selected_Unit

    if(!this.unit_correction)
      this.unit_correction=this.Selected_Unit

    if(!this.unit_correction_eqution)
      this.unit_correction_eqution=this.Selected_Unit

    if(!this.unit_uncertainy)
      this.unit_uncertainy=this.Selected_Unit

    if(!this.unit_zfactor)
      this.unit_zfactor=this.Selected_Unit

    this.modalRef_Unit.hide()
  }

  //#endregion

  //#region LabAddress

  Set_LabAddress_click(input:string) {
    this.Calibration_Device.labAdderss=input
  }

  //#endregion


  //#region Calibration
  Calibration_Device: Calibration_Interface = Empty_Calibration_Interface();
  Set_CalibrationDeviceInfo_click(input:Calibration_Interface){
    this.Calibration_Device=input
  }

  //#endregion

  modalRef_After: any;
  modalRef_Code: any;

  onSubmit(template: TemplateRef<any>) {


    var HasCompleteForm:number=-1
    var HasMinObservation: number = -1

    for (let item of this.Nominal_Value_List)
    {
      if (!item.PA || item.PA == "0")
      {
        HasCompleteForm=this.Nominal_Value_List.indexOf(item)
        break
      }

    }

    for (let item of this.Nominal_Value_List)
    {
      if (item.mesured.length < this.Observation)
      {
        HasMinObservation=this.Nominal_Value_List.indexOf(item)
        break
      }

    }

    if (HasCompleteForm>-1)
    {
      this.Alerify_Service.ErrorMessage("مقدار محیط را برای ردیف "+(HasCompleteForm+1)+" وارد نمائید")
    }
    else if (HasMinObservation>-1)
    {
      this.Alerify_Service.ErrorMessage("ردیف "+(HasCompleteForm+1)+" فاقد حداقل Measure می باشد. حداقل Measure "+(this.Observation)+" است.")
    }
    else if (!this.DELIVERY_TIME && this.DELIVERY_TIME < 0)
    {
      this.Alerify_Service.ErrorMessage("مقدار DELIVERY TIME (second) را بررسی نمائید.")
    }
    else {
      this.InProccessing = true;
      var temp: DataEntity_Main_02_Interface = Empty_DataEntity_Main_02_Interface();

      temp.id = this.Calibration_Id;

      temp.unit_nomimal = this.unit_nomimal;
      temp.unit_reference = this.unit_reference;
      temp.unit_correction = this.unit_correction;
      temp.unit_correction_eqution = this.unit_correction_eqution;
      temp.unit_uncertainy = this.unit_uncertainy;
      temp.unit_zfactor = this.unit_zfactor;

      this.DataEntity02_Service.Submit(
        temp,
        this.Nominal_Value_List,
        this.DataEntity_Id,
        this.Calibration_Device_Id,
        this.FileName,
        this.FolderName,
        this.Capability,
        
        this.Manufacture_txt,
        this.Type_txt,
        this.Model_txt,
        this.DELIVERY_TIME,
        this.Calibration_Device.labAdderss).subscribe((data) => {
        this.InProccessing = false;
        if (data['id'] == -1) {
          this.Alerify_Service.ErrorMessage(data['dsc'] )
        }
        else if (data['certificate_Code'] == '') {
          this.Alerify_Service.ErrorMessage('خطا سیستمی');
        } else {
          this.CertificateCode = data['certificate_Code'];
          this.Alerify_Service.SuccessMessage('اطلاعات ثبت شد');


          if (data['certificateUrl'])
            this.CertificateUrlPdf = environment.BaseUrl + data['certificateUrl']
          else
            this.CertificateUrlPdf = ""

          this.modalRef_Code = this.modalService.show(template);
        }
      });

    }
  }

  SubmitDATEOFISSUE_Date: string = '';

  onSubmitDATEOFISSUE() {
    if (
      !this.SubmitDATEOFISSUE_Date ||
      this.SubmitDATEOFISSUE_Date == undefined
    ) {
      this.Alerify_Service.ErrorMessage('تاریخ را وارد نمائید');
    } else {
      this.DataEntityMain_Service.SubmitDateOfIssue(
        this.Calibration_Device_Id,
        this.SubmitDATEOFISSUE_Date
      ).subscribe((data) => {
        this.Alerify_Service.SuccessMessage('اطلاعات ثبت شد');
      });
    }
  }

}
